
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
import { Heading } from '@/components/Heading'
import { TipGood, TipBad } from '@/components/Tip'
import { CodeSample } from '@/components/CodeSample'
const Layout = _Layout;
const meta = {
  "id": "delivery",
  "title": "Delivery Methods",
  "sidebar_label": "Delivery"
};
const slug = 'delivery';
const tableOfContents = [{
  "title": "Benefits for Marketplace Owners",
  "slug": "benefits-for-marketplace-owners",
  "children": []
}, {
  "title": "Benefits for Sellers",
  "slug": "benefits-for-sellers",
  "children": []
}, {
  "title": "Setting Up Shipping Methods",
  "slug": "setting-up-shipping-methods",
  "children": []
}, {
  "title": "Selecting a Shipping Method at the Account Level (Merchant)",
  "slug": "selecting-a-shipping-method-at-the-account-level-merchant",
  "children": []
}, {
  "title": "Which Method to choose?",
  "slug": "which-method-to-choose",
  "children": []
}, {
  "title": "Video Configuring Shipping/Delivery Methods",
  "slug": "video-configuring-shipping-delivery-methods",
  "children": []
}, {
  "title": "ORDER ONLINE & PICK UP",
  "slug": "order-online-and-pick-up",
  "children": []
}, {
  "title": "DELIVERY",
  "slug": "delivery",
  "children": []
}, {
  "title": "FULLFILLMENT by PLATFORM",
  "slug": "fullfillment-by-platform",
  "children": []
}, {
  "title": "Delivery Return Flow",
  "slug": "delivery-return-flow",
  "children": []
}, {
  "title": "User App",
  "slug": "user-app",
  "children": []
}, {
  "title": "OUR ROADMAP",
  "slug": "our-roadmap",
  "children": [{
    "title": "Integrating with Shippo, Easypost",
    "slug": "integrating-with-shippo-easypost",
    "children": []
  }]
}];

const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">







    <p><a parentName="p" {...{
        "href": "https://developer.tradly.app/#d0ca034b-2288-4ee2-a995-916ee3ffd8be"
      }}>{`API REFERENCE`}</a>{` | `}<a parentName="p" {...{
        "href": "https://superadmin.tradly.app/delivery"
      }}>{`Visit SuperAdmin`}</a></p>
    <div class="relative">
      <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/shipping-service1.png" alt="Delivery Services" />
    </div>
    <p>{`The “Shipping Method” feature allows marketplace owners to specify the shipping options that are available to sellers on the platform. Sellers can then select from these options when setting up their listings for sale.`}</p>
    <_Heading level={2} id={"benefits-for-marketplace-owners"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": true
    }}>Benefits for Marketplace Owners</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li">{`Control over shipping options: Marketplace owners have control over the shipping options that are available to sellers on the platform, allowing them to offer the options that best meet the needs of their business and customers.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Simplified shipping setup: By providing a predefined set of shipping options, marketplace owners can streamline the shipping setup process for sellers and reduce the risk of errors or inconsistencies.`}</p>
      </li>
    </ul>
    <_Heading level={2} id={"benefits-for-sellers"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": true
    }}>Benefits for Sellers</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li">{`Flexibility in shipping options: Sellers can choose from the shipping options provided by the marketplace owner when setting up their listings for sale, allowing them to offer a range of options to their customers.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Simplified shipping setup: By being able to select from a predefined set of shipping options, sellers can save time and effort in setting up their listings for shipping.`}</p>
      </li>
    </ul>
    <p><strong parentName="p">{`You need to enabled shipping method preference for accounts for them to have this control`}</strong></p>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/shipping-method-preference.png" />
    </div>
    <_Heading level={2} id={"setting-up-shipping-methods"} nextElement={{
      "type": "paragraph"
    }}>Setting Up Shipping Methods</_Heading>
    <p>{`To set up shipping methods for your online marketplace, follow these steps:`}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Login to your marketplace owner account and navigate to the `}<inlineCode parentName="li">{`Settings`}</inlineCode>{` page.`}</li>
      <li parentName="ol">{`Scroll down to the `}<inlineCode parentName="li">{`Shipping Method`}</inlineCode>{` section.`}</li>
      <li parentName="ol">{`Click `}<inlineCode parentName="li">{`Add Shipping Method`}</inlineCode>{` to add a new shipping option.`}</li>
      <li parentName="ol">{`Enter the name of the shipping method and any other relevant details (e.g. price, delivery time).`}</li>
      <li parentName="ol">{`Click `}<inlineCode parentName="li">{`Save`}</inlineCode>{` to apply the changes.`}</li>
    </ol>
    <p>{`To enable sellers to select shipping methods when setting up their listings for sale, make sure to enable the `}<inlineCode parentName="p">{`Allow Sellers to Choose Shipping Method`}</inlineCode>{` option in the `}<inlineCode parentName="p">{`Shipping Method`}</inlineCode>{` section.`}</p>
    <_Heading level={2} id={"selecting-a-shipping-method-at-the-account-level-merchant"} nextElement={{
      "type": "paragraph"
    }}>Selecting a Shipping Method at the Account Level (Merchant)</_Heading>
    <p>{`“Go to Marketplace Website (Not Superadmin)”
To select a shipping method on an account level (merchant), follow these steps:`}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Login to your seller account and navigate to the `}<inlineCode parentName="li">{`Account`}</inlineCode>{` page.`}</li>
      <li parentName="ol">{`Edit the account page by clicking the “Edit” button.`}</li>
      <li parentName="ol">{`Scroll down to the `}<inlineCode parentName="li">{`Shipping Method`}</inlineCode>{` section.`}</li>
      <li parentName="ol">{`Select your desired shipping method from the available options.`}</li>
      <li parentName="ol">{`Click “Save” to apply the changes.`}</li>
    </ol>
    <p>{`After selecting a shipping method at the account level, this method will be the default option for all of your listings. However, you also have the option to override the account-level shipping method and select a different method for individual listings (see “Selecting a Shipping Method for a Product” below).`}</p>
    <p>{`You can test the buying experience with a dummy account, where only the shipping method selected at the account level will be visible for every listing.`}</p>
    <_Heading level={2} id={"which-method-to-choose"} nextElement={{
      "type": "paragraph"
    }}>Which Method to choose?</_Heading>
    <p>{`Delivery is one of the important functionality of a marketplace. You need to decide the delivery method you want to offer in your marketplace carefully. It depends on how you charge your customers, you can opt for different methods.`}</p>
    <p><strong parentName="p">{`Less operation centric:`}</strong></p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`You totally leave the delivery and shipping to your customers(sellers)`}</li>
      <li parentName="ul">{`They take care from accepting the order, updating the order status and delivering the listing`}</li>
      <li parentName="ul">{`Our functionality provides where they can change order status in order detail page. Read more about it on `}<a parentName="li" {...{
          "href": "notifications"
        }}>{`Notifications page`}</a></li>
      <li parentName="ul">{`Highly suitable for business which want to take less commission % from every sales OR Software monthly subscription where you just want to charge for the usage of your app OR open marketplace with just discovery and free `}</li>
    </ul>
    <p><strong parentName="p">{`Balanced operation: (On Process)`}</strong></p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Your app provides the integration with logistics players like DHL, UPL, etc (Read more on below integration section)`}</li>
      <li parentName="ul">{`So, whenever the order status moved from order success page, our system can notify your logistic partner to pick up and deliver the listing`}</li>
      <li parentName="ul">{`Suitable for business which want to take commission not more than 15% or subscription-based revenue model or other custom options.`}</li>
    </ul>
    <p>{`**Highly regulated operation:
UPDATE: Tradly Fleet solution is available on a closed beta. if you are interested, submit the details in contact form. `}</p>
    <p>{`One of the tough and lot of operation work needed in this approach. Operational team must for this.`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`You care of every step from order happened to delivery to return to disputes (you need to monitor, manage and execute the delivery)`}</li>
      <li parentName="ul">{`listing marketplace like Amazon does this model`}</li>
      <li parentName="ul">{`On-demand delivery like deliveroo, postmates, etc work on this model `}</li>
      <li parentName="ul">{`You work with multiple logistics partner to achieve this. `}</li>
      <li parentName="ul">{`OR You own a fleet of delivery boys and logistics to handle the delivery options `}</li>
    </ul>
    <p>{`There are different types of delivery methods we provide. One of the emerging mode of user behaviour after COVID-19 is order online and pick up from store. `}</p>
    <_Heading level={2} id={"video-configuring-shipping-delivery-methods"} nextElement={{
      "type": "paragraph"
    }}>Video Configuring Shipping/Delivery Methods</_Heading>
    <p>{`Watch from the 11th minutes. `}</p>
    <div class="aspect-w-16 aspect-h-9">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/zyVf4t5U_GE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>
    <_Heading level={2} id={"order-online-and-pick-up"} nextElement={{
      "type": "paragraph"
    }}>ORDER ONLINE & PICK UP</_Heading>
    <p>{`Your sellers can choose if they want to allow any or both of `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Pickup `}</li>
      <li parentName="ul">{`Delivery
And you can control this from marketplace level as well. `}</li>
    </ul>
    <p>{`Example:`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`if you allow delivery only, your sellers left with one option of delivery `}</li>
      <li parentName="ul">{`If you allow delivery or pickup, your sellers can choose which is their preference when they create their store/account`}</li>
    </ul>
    <p><strong parentName="p">{`Highly suitable `}</strong></p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`For stores which can’t do delivery easily. Applicable for most local stores, shopping mall-based stores.`}</li>
      <li parentName="ul">{`For cities which doesn’t have delivery network or on-demand delivery services `}
        <img src="/img/shipment.png" alt="navbar" width="400" />
      </li>
    </ul>
    <_Heading level={2} id={"delivery"} nextElement={{
      "type": "paragraph"
    }}>DELIVERY</_Heading>
    <p>{`Your sellers can opt to deliver the listing by themselves without logistic player or using delivery boys. Or even they can use other 3rd party to provide the delivery and just update the order status through Tradly Platform powered apps. `}</p>
    <p>{`Suitable for`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Local, Nearby based marketplace where the sellers and buyers located closely (within 15-25 km)`}</li>
      <li parentName="ul">{`They can do their delivery options `}</li>
    </ul>
    <_Heading level={2} id={"fullfillment-by-platform"} nextElement={{
      "type": "paragraph"
    }}>FULLFILLMENT by PLATFORM</_Heading>
    <p>{`As a platform owner, you can decide which items to fulfill yourself and which items to fulfill through the seller. Your buyers will be able to see the items fulfilled by the platform in product listings and during checkout.`}</p>
    <p>{`At any point of time, you may also move back the item to be fullfilled by seller instead of the platform. `}</p>
    <_Heading level={2} id={"delivery-return-flow"} nextElement={{
      "type": "paragraph"
    }}>Delivery Return Flow</_Heading>
    <p>{`The return flow is simple and straightforward.`}</p>
    <p><strong parentName="p">{`Return Initiate: `}</strong>{`
When a customer wants to make a return for any reason, he can initiate it by going to the order detail page and selecting “Custom Return initiation” option.`}</p>
    <p><strong parentName="p">{`Return Restriction: `}</strong>{`
The merchant can decide the return policy for the listing. The return policy will govern if the listing is returnable or not. The return policy may include a “No returns” listing, “n Day returns”, or ”# Days replacement only”.`}</p>
    <p><strong parentName="p">{`Marketplace Support & accepting returns: `}</strong>{`
The seller will have an option to chat with the customer for the relevant customer to identify and rectify the problem if possible. However, if the problem couldn’t be rectified then the seller can choose to accept the return, & could plan a return pickup & communicate with the delivery partner for the same.
Both the merchant and the customer can check the return status from the return status page.`}</p>
    <_Heading level={2} id={"user-app"} nextElement={{
      "type": "paragraph"
    }}>User App</_Heading>
    <p>{`User able to save multiple shipping address based on his circumstances to choose`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Add unlimited shipping address in his profiles`}</li>
      <li parentName="ul">{`Select different delivery address on every new orders `}</li>
      <li parentName="ul">{`Edit, Delete shipping address. `}</li>
    </ul>
    <_Heading level={2} id={"our-roadmap"} nextElement={{
      "type": "heading",
      "depth": 3
    }}>OUR ROADMAP</_Heading>
    <_Heading level={3} id={"integrating-with-shippo-easypost"} nextElement={{
      "type": "paragraph"
    }}>Integrating with Shippo, Easypost</_Heading>
    <p>{`Shippo and Easy post are aggregators of logistic players like DHL, UPX, etc. They have 50+ players connected under them. So by integrating our orderAPI with those platforms, you will be able to use any logistic players they support.`}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
